export class ObjectNodeBunch{
    bunch:any;
    listCamera: any[] = [];
    listChild : any[] = [];
    isActive: boolean = false;
    isClick: boolean = false;
    level: any = 0;
    indexParent: any;
    displayIndex: any;
}